<template>
  <div>
    <div class="container">
      Contact
    </div>
    <div>
      Rocket vector illustration credit:
      <a href="https://www.Vecteezy.com">
        Vecteezy
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
